<ng-container *ngIf="content$ | async as content">
  <div class="teaser-list grid-col-12 no-gutters">
    <ng-container *ngIf="content.subjectTaxonomyTags.includes(TAXONOMY.QUERY_LIST_TEASER_STYLE); else default">
      <fin-teaser
        *ngFor="let teaserItem of content.items"
        [class]="content.gridClass || 'col-1-12 md-col-1-8'"
        [content]="teaserItem"
      ></fin-teaser>
    </ng-container>
    <ng-template #default>
      <fin-teaser-card
        *ngFor="let teaserItem of content.items"
        class="col-1-12 teaser-wrapper"
        [aspectRatio]="'16x9'"
        [content]="teaserItem"
      ></fin-teaser-card>
    </ng-template>
  </div>
</ng-container>
